import { useEffect } from 'react';

import { shallowEqual, useSelector } from 'react-redux';

import { selectUser } from '@/redux/user/selectors';
import { User } from '@/shared/types/user';
import { getRoles } from '@/util/util';

import { useAccount } from './useAccount';
import useMembers from './useMembers';

export const useBeamer = () => {
  const user = useSelector(selectUser, shallowEqual) as User | null;
  const { account, accountRole } = useAccount();
  const { member } = useMembers();
  const role_ids = member?.role_ids;
  const isBeamerConfigSet = window.beamer_config !== undefined;

  const { isBuilder, isChatManager, isAdminOrOwner, isChatAgent } = getRoles(role_ids, accountRole);

  useEffect(() => {
    if (!user || !account || isBeamerConfigSet) {
      return;
    }
    let filter = `slug:${account.slug};plan:${account.plan_id};`;
    if (isBuilder) {
      filter += `role:builder;`;
    }
    if (isChatManager) {
      filter += `role:chat_manager;`;
    }
    if (isAdminOrOwner) {
      filter += `role:admin;`;
    }
    if (isChatAgent) {
      filter += `role:chat_agent;`;
    }

    const domain = user.email.split('@')[1];
    if (domain) {
      filter += `domain:${domain}`;
    }

    window.beamer_config = {
      product_id: 'ohnQggJb49523',
      selector: '.beamer',
      //---------------Visitor Information---------------
      user_firstname: user.name,
      user_email: user.email,
      user_id: user.user_id,
      filter,
    };
    const script = document.createElement('script');
    script.src = 'https://app.getbeamer.com/js/beamer-embed.js';
    script.async = true;
    script.id = 'moveo-changelog';
    document.body.appendChild(script);
  }, [user, isBeamerConfigSet, account, isBuilder, isChatManager, isAdminOrOwner, isChatAgent]);
};
